import React from 'react';

// Erwartet: fields = [{type,name,label?,text?,html?,required,options?,rows?,placeholder?}]
export default function FormPreview({ fields }) {
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {(fields || []).map(f => {
        const key = f.id || f.name || Math.random();
        const star = f.required ? <span style={{ color: 'crimson' }}> *</span> : null;

        // Text, E-Mail, Phone
        if (f.type === 'text' || f.type === 'email' || f.type === 'phone') {
          return (
            <div key={key} className="field">
              <label><strong>{f.label || '(Label)'}</strong>{star}</label>
              <input
                type={f.type === 'phone' ? 'tel' : f.type}
                placeholder={f.placeholder || ''}
                disabled
              />
            </div>
          );
        }

        // Mehrzeiliger Text
        if (f.type === 'textarea') {
          return (
            <div key={key} className="field">
              <label><strong>{f.label || '(Label)'}</strong>{star}</label>
              <textarea rows={f.rows || 3} placeholder={f.placeholder || ''} disabled />
            </div>
          );
        }

        // Radio
        if (f.type === 'radio') {
          return (
            <div key={key} className="field">
              <label><strong>{f.label || '(Label)'}</strong>{star}</label>
              {(f.options || []).map(o => (
                <div key={o.value} className="form-check">
                  <input className="form-check-input" type="radio" disabled />
                  <label className="form-check-label">{o.label}</label>
                </div>
              ))}
            </div>
          );
        }

        // Select
        if (f.type === 'select') {
          return (
            <div key={key} className="field">
              <label><strong>{f.label || '(Label)'}</strong>{star}</label>
              <select disabled>
                <option value="">Bitte wählen…</option>
                {(f.options || []).map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          );
        }

        // Einzel-Checkbox
        if (f.type === 'checkbox') {
          return (
            <div key={key} className="field">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label">
                  <strong>{f.label || '(Label)'}</strong>{star}
                </label>
              </div>
            </div>
          );
        }

        // Checkbox-Gruppe
        if (f.type === 'checkbox_group') {
          return (
            <div key={key} className="field">
              <label><strong>{f.label || '(Label)'}</strong>{star}</label>
              {(f.options || []).map(o => (
                <div key={o.value} className="form-check">
                  <input className="form-check-input" type="checkbox" disabled />
                  <label className="form-check-label">{o.label}</label>
                </div>
              ))}
            </div>
          );
        }

        // Consent (HTML erlaubt)
        if (f.type === 'consent') {
          const html = f.html ?? f.text ?? 'Einwilligungstext …';
          return (
            <div key={key} className="field">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label">
                  <span dangerouslySetInnerHTML={{ __html: html }} />
                  {star}
                </label>
              </div>
            </div>
          );
        }

        return <div key={key}><em>Unbekannter Typ: {String(f.type)}</em></div>;
      })}
    </div>
  );
}